import { Controller } from '@hotwired/stimulus'

// Shows only the discount fields that make sense for the chosen target, type,
// and duration; the server normalizes whatever is hidden. ISSUE-3820.
export default class extends Controller {
  static targets = ['applyOn', 'discountType', 'durationType',
                    'quoteWrap', 'percentageWrap', 'amountWrap', 'durationWrap', 'periodWrap']

  connect() {
    this.sync()
  }

  sync() {
    const applyOn = this.applyOnTarget.value
    const oneTimeBucket = applyOn === 'one_time_total' || applyOn === 'quote_onboarding_fee'

    this.toggle(this.quoteWrapTarget, applyOn.startsWith('quote_'))
    this.toggle(this.percentageWrapTarget, this.discountTypeTarget.value === 'percentage')
    this.toggle(this.amountWrapTarget, this.discountTypeTarget.value === 'fixed_amount')
    this.durationWrapTargets.forEach((element) => this.toggle(element, !oneTimeBucket))
    this.toggle(this.periodWrapTarget, !oneTimeBucket && this.durationTypeTarget.value === 'limited_period')
  }

  toggle(element, visible) {
    element.classList.toggle('d-none', !visible)
  }
}
